import React, {PureComponent} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {Header, Partners, Summary, SummaryGroup} from '../../components';
import {get} from '../../redux/modules/home';

class Home extends PureComponent {

  componentWillMount() {
    this.props.getHome();
  }

  render() {
    const {home: {values, isFetching}} = this.props;

    if (isFetching) {
      return <div/>;
    }

    return (
      <div>
        <div className="home-img">
          <Header {...values.home}/>
        </div>
        <Summary info={values.news}/>
        <SummaryGroup lastNews={values.last_news} articles={values.articles}/>
        <Partners listOfPartners={values.partners}/>
      </div>
    );
  }
}

export default connect(
  (state) => {
    return {
      home: state.home
    };
  },
  (dispatch) => {
    return bindActionCreators(
      {
        getHome: get
      }, dispatch);
  }
)(Home);



// WEBPACK FOOTER //
// ./src/containers/home/Home.js